'use client';
import React, { FC } from 'react';
import Slider from 'react-slick';
import { DynamicComponent, HeaderText, UniversalCta } from '@/components';
import { TypeGenericCarouselFields } from '@/core/generated-types';
import { generateSliderSettings } from '@/components/common/GenericCarousel/generateSliderSettings';
import { HeaderSize } from '@/components/ui/HeaderText';
import { BackgroundColorWrapper } from '@/components/common/BackgroundColorWrapper';

const GenericCarousel: FC<TypeGenericCarouselFields> = ({
  slides,
  styleVariant,
  title,
  backgroundColor,
  cta,
  anchorId,
}) => {
  if (!slides) return null;

  const settings = generateSliderSettings(styleVariant);
  const styleVariantClassName = `mx-auto container ${
    styleVariant ? `slider-variant-${styleVariant}` : ''
  }`;

  return (
    <BackgroundColorWrapper
      color={backgroundColor?.fields?.color}
      classes="lg:py-20 py-10 px-6"
    >
      <div
        className={styleVariantClassName}
        data-testid="custom-styles-applied-here"
        id={anchorId}
      >
        {title && (
          <HeaderText
            size={HeaderSize.H2}
            text={title}
            align="center"
            classes="pb-4 md:pb-9 title-container"
          />
        )}
        <Slider {...settings}>
          {slides &&
            slides.map((slide, i) => {
              return (
                // The following styles ensure slides are centered in the slider
                <div
                  key={`${slide.sys.id}-${i}`}
                  className="!flex h-full justify-center"
                >
                  <DynamicComponent component={slide} />
                </div>
              );
            })}
        </Slider>
      </div>
      {cta && (
        <div className="flex justify-center">
          <UniversalCta link={cta} className="mx-auto text-center my-8" />
        </div>
      )}
    </BackgroundColorWrapper>
  );
};

export default GenericCarousel;
